<user-groups-list
  (filter)="filters = $event"
  [userGroups]="userGroups$ | async"
  [activeItem]="activeUserGroup$ | async"
  (ngSelect)="onSelect($event)"
  class="border-separator-right dock-y"
></user-groups-list>

@if (activeUserGroupId) {
  <div
    style="display: grid; grid-template-columns: var(--mgmt-col) auto"
    class="fill-height"
    >
    <div class="border-separator right h-100 overflow-hidden">
      <user-group-linked-users-editor
        [filteredUser]="filters.user"
        style="border-right: 5px solid #d5d5d5 !important"
        class="dock-y"
        [userGroup]="activeUserGroup$ | async"
      ></user-group-linked-users-editor>
    </div>
    <div class="border-separator right h-100 overflow-hidden">
      <user-group-app-links
        [filteredApp]="filters.app"
        [activeUserGroup]="activeUserGroup$ | async"
        class="fill-height"
      ></user-group-app-links>
    </div>
  </div>
}
